import { Component, OnInit } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from 'angularfire2/storage';
import { AngularFireDatabase, AngularFireList  } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';
import { FileSizePipe } from '../pipe/file-size.pipe'
import { NgForm } from '@angular/forms';
import { FormsModule }   from '@angular/forms';
import { Router } from '@angular/router';
import { Card } from '../../../class/card';
import { AngularFireAuth } from 'angularfire2/auth';
import swal from 'sweetalert2'

@Component({
  selector: 'file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent {

  title = 'タイトル'
  link = 'リンク先を入力（例：http/・・・）'
  userkey: string;
  photoskey: string;
  cardkey: string;
  cards: Card[];

  cardsRef: AngularFireList<any>;

  // Main task 
  task: AngularFireUploadTask;

  // Progress monitoring
  percentage: Observable<number>;

  snapshot: Observable<any>;

  // Download URL
  downloadURL: Observable<string>;

  // State for dropzone CSS toggling
  isHovering: boolean;

  constructor(
    private router: Router,
    private storage: AngularFireStorage,
    private store: AngularFirestore,
    private db: AngularFireDatabase,
    private afAuth: AngularFireAuth  ) { 
      this.cardsRef = this.db.list('cards');
      this.afAuth.auth.onAuthStateChanged(user => {
        if (user) {
          this.userkey = `users/${user.uid}/cards`;
          this.photoskey = `userphotos/${user.uid}/`;
        } else {
          this.userkey = 'cards';
          this.photoskey = 'photos/';
        }
        this.cardsRef = this.db.list(this.userkey, ref  => ref.orderByChild('index'));
      });
    }
  

  addCard(f: NgForm): void {
    if(!f.value.title || f.value.title==='タイトル'){
      swal({
        title: 'カード作成失敗',
        text: 'タイトルを入力してください。',
        type: 'error',
        confirmButtonText: 'OK'
      })
      return;
    }
    if(!f.value.link || f.value.link==='リンク先を入力（例：http/・・・）'){
      swal({
        title: 'カード作成失敗',
        text: 'リンク先を入力してください。',
        type: 'error',
        confirmButtonText: 'OK'
      })
      return;
    }
    if(!f.value.url){
      swal({
        title: 'カード作成失敗',
        text: '画像を設定してください。',
        type: 'error',
        confirmButtonText: 'OK'
      })
      return;
    }
    this.cardsRef.push(new Card({title: f.value.title, link: f.value.link, pic: f.value.url}));    
    this.router.navigate(['/']);
  }

  toggleHover(event: boolean) {
    this.isHovering = event;
  }

  startUpload(event: FileList) {
    // The File object
    const file = event.item(0)

    // Client-side validation example
    if (file.type.split('/')[0] !== 'image') { 
      console.error('unsupported file type :( ')
      swal({
        title: 'アップロード失敗',
        text: '画像ファイルのみアップロードできます。',
        type: 'error',
        confirmButtonText: 'OK'
      })
      return;
    }
    
    // Client side file size verification let about 7kb 
    if (file.size > 800000) { 
      console.error('unsupported file size over :( ')
      swal({
        title: 'アップロード失敗',
        text: '画像サイズのアップロード上限は700kBです。',
        type: 'error',
        confirmButtonText: 'OK'
      })
      return;
    }

    // The storage path
    const path = `${this.photoskey}${new Date().getTime()}_${file.name}`;

    // Totally optional metadata
    const customMetadata = { app: 'My AngularFire-powered PWA!' };

    // The main task
    this.task = this.storage.upload(path, file, { customMetadata })

    // Progress monitoring
    this.percentage = this.task.percentageChanges();
    this.snapshot = this.task.snapshotChanges().pipe(
      tap(snap => {
        if (snap.bytesTransferred === snap.totalBytes) {
          // Update firestore on completion
          this.store.collection('photos').add( { path , size: snap.totalBytes })
        }
      })
    )

    // The file's download URL
    this.downloadURL = this.task.downloadURL(); 
  }

  // Determines if the upload task is active
  isActive(snapshot) {
    return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes
  }

  titlestyle(){
    let styles = {
      'font-size': this.title.length>5 ? `${-0.1114 * this.title.length + 2.119 }rem` : '1.75rem',
      'padding' : this.title.length>5 ? `${0.0874 * this.title.length - 0.399 }rem 0rem` : '0rem' 
    }
    return styles;
  }
}


// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/card/new/file-upload/file-upload.component.ts